<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Asiento</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
<!--           <th scope="col"></th> -->
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">Descripción</th>
          <th scope="col">EstadoAsiento</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="asiento in datosPaginados" :key="asiento.idAsiento">
<!--           <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(asiento.idAsiento)" title="Editar">edit_square</i></td> -->
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(asiento.idAsiento)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(asiento.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(asiento.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{asiento.descripcion}}</td>
          <td>{{asiento.estadoAsiento}}</td>
          <td>{{asiento.empresaNombre}}</td>
          <td>
            <select class="form-select form-select-sm" @change="handleAction($event, atencion.idAtencion)">
              <option disabled selected>Seleccione...</option>
              <option value="editar">Editar</option>
              <option value="detalles">Detalles</option>
              <option value="borrar">Borrar</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAsiento" class="form-label">IdAsiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsiento" name="idAsiento" v-model="datoAsiento.idAsiento" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoAsiento.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoAsiento.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAsiento.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAsiento.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoAsiento.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="estadoAsiento" class="form-label">EstadoAsiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="estadoAsiento" name="estadoAsiento" v-model="datoAsiento.estadoAsiento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAsiento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsiento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsientoEstado" v-if="btnEditar">Listo</button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      asientos : [],
      datoAsiento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    handleAction(event, idAtencion) {
      const action = event.target.value;
      if (action === 'editar') {
        this.abrirModalEditar(idAtencion);  
      } else if (action === 'detalles') {
        this.abrirEditar(idAtencion);
      } else if (action === 'borrar') {
        this.deletePersona(idAtencion);
      }
      // Restablecer el valor del select a su estado predeterminado
      event.target.value = 'Seleccione...';
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.asientos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwasientos/nombre/'+this.nombreBusqueda).then(response=>{
          this.asientos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.asientos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwasientos').then(response=>{
      this.asientos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.asientos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'descripcion'
        ,'estadoAsiento'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'descripcion'
        ,'estadoAsiento'
      ];
      return validarForm(this.datoAsiento, requiredFields, requiredFieldsText);
    },
    async guardarAsiento(){
      if(this.validarForm() === 1){
        try {
          this.datoAsiento.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          this.datoAsiento.idUsuarioReg = window.sessionStorage.getItem("idUsuarioReg");
          await api.post('/asientos', this.datoAsiento)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Asiento creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsiento(){
      if(this.validarForm() === 1){
        try {
          this.datoAsiento.idUsuarioAct = window.sessionStorage.getItem("idUsuarioAct");
          await api.post('/asientos', this.datoAsiento)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Asiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    async guardarEditAsientoEstado(){
      if(this.validarForm() === 1){
          this.datoAsiento.estadoAsiento = "PENDIENTE";
        try {
          await api.post('/asientos', this.datoAsiento)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Asiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAsiento={}
      this.titulo   = 'Crear Asiento'
      this.btnCrear = true
      this.btnEditar= false
    },
/*     abrirModalEditar(idAsiento){
      this.modalWindow = true
      if(idAsiento != null){    
           api.get('/vwasientos/'+idAsiento).then(resp=>{
          this.datoAsiento = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Asiento'
      this.btnCrear = false
      this.btnEditar= true
    }, */
    abrirEditar(idAsiento){
      if(idAsiento != null){
        this.$router.push('/asiento_asientodet/'+idAsiento)
      }
    },
    async deleteAsiento (idAsiento) {
      try{
        await api.delete('/asientos/'+idAsiento)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
